import Raven from 'raven-js';
import UAFormat from 'ua-format-js';
import _ from 'lodash';
import { DEPLOY_ENV, CLIENT_ID, PACKAGE_VERSION } from '@cores/constants/envConfig';
import { getSentryUrlByEnv } from '@cores/constants/sentry-config';
const regionList = ['CN', 'US', 'EU'];
let unPushedTrackEventsStack = [];
// deployEnv的值可能是ci, qa, release, cn, us, eu
// ci, qa, release默认使用CN
function getRegion() {
    const deployEnv = _.upperCase(DEPLOY_ENV);
    return _.includes(regionList, deployEnv) ? deployEnv : 'CN';
}
export default (page, opts = {}) => {
    const cid = CLIENT_ID;
    let init = false;
    const email = opts.email;
    const accountId = opts.accountId;
    const companyId = opts.companyId;
    const companyName = opts.companyName;
    const userType = opts.userType;
    const needTrack = opts.needTrack;
    const formatter = new UAFormat();
    const UAresult = formatter.getResult();
    if (needTrack && window.location.search.indexOf('noraven=1') < 0) {
        const data = {
            id: accountId,
            email,
            os: UAresult.os.name,
            browser: UAresult.browser.name,
            b_ver: UAresult.browser.version,
            account_id_cipher: accountId,
            company_id_cipher: companyId,
            company_name: companyName,
            user_type: userType,
        };
        if (cid) {
            Object.assign(data, { client_id: cid });
        }
        const url = getSentryUrlByEnv(DEPLOY_ENV);
        if (url) {
            Raven.config(url, {
                release: PACKAGE_VERSION,
                environment: DEPLOY_ENV,
                ignoreUrls: ['daovoice', 'walkme', 'fullstory', 'segment.io', 'qiyukf', 'nr-data', 'zdassets.com', 'pendo'],
            }).install();
        }
        Raven.setUserContext(data);
        import('@patsnap/common-ps-tracer')
            .then(m => (m.default ? m.default : m))
            .then(sentryPsPlugin => {
            sentryPsPlugin(Raven, {
                redShiftIntegrationName: 'redshift-segmentdb',
                product: 'Workspace',
                page: page,
                openSpendTimeTrack: true,
            });
        })
            .then(() => {
            unPushedTrackEventsStack.forEach(trackData => {
                const region = getRegion();
                trackData.attr = _.merge(trackData.attr, {
                    region,
                });
                Raven.insertMeta(trackData);
            });
            unPushedTrackEventsStack = [];
        });
    }
    if (!init) {
        init = true;
    }
};
const RavenInsertMeta = (category, action, attr) => {
    if (!Raven.insertMeta) {
        return;
    }
    const region = getRegion();
    attr = _.merge({
        source: _.get(window, 'zPREFACE.trackData.source', category),
        region,
    }, attr);
    const trackData = {
        module: category,
        action,
        attr,
    };
    Raven.insertMeta(trackData);
};
Raven.insertMeta = Raven.insertMeta
    ? Raven.insertMeta
    : (trackData) => {
        console.warn('ps-tracer not inited!');
        unPushedTrackEventsStack.push(trackData);
    };
export { RavenInsertMeta, Raven };
